_ = require 'underscore'
BaseDirectoryView = require './base-directory-view'
DirectoryPluginItemView = require './directory-plugin-item-view'
t = require('views/internal/recup-with-helpers')('directory_home')
React = require 'react'

{ Carousel } = require '@trello/directory-components'
{ featuredCarouselData } = require 'data/directory'

class CarouselImage extends React.Component
  render: t.renderable ->
    { src, href, title } = @props
    t.a { href, target: '_blank' }, ->
      t.img '.directory-carousel-item', { src, title }

class DirectoryHomeComponent extends React.Component
  displayName: 'Directory Home'

  render: t.renderable ->
    t.div ->
      t.div '.directory-carousel', ->
        t.tag Carousel, {
          children: _.map featuredCarouselData, ({ title, image, link }, index) =>
            React.createElement CarouselImage, { src: image, href: link, title: title, key: index }
        }
      t.div '.directory-content-body', ->
        t.h2 ->
          t.format 'tacos-picks'
        t.div '.directory-featured-powerups'

module.exports = class DirectoryHomeView extends BaseDirectoryView
  renderContent: ->
    React.createElement DirectoryHomeComponent

  render: ->
    super

    { plugins, currentPage, directoryView } = @options

    pluginItemSubviews = _.map plugins, (plugin) =>
      @subview(DirectoryPluginItemView, @model, {
        atomType: 'featured'
        currentPage
        plugin
        directoryView
      }, plugin.id)

    powerUpsContainer = @$el.find('.directory-featured-powerups')
    @appendSubviews(pluginItemSubviews, powerUpsContainer)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-home-view.coffee